export type FactoryAddressSession = {
  province_id?: number | null;
  province_name?: string | null;
  district_id?: number | null;
  district_name?: string | null;
  sub_district_id?: number | null;
  sub_district_name?: string | null;
  zip_code?: number | string | null;
};

const STORAGE_KEY = "factory_address_session_v1";

export function saveFactoryAddressSession(addressFac?: any): FactoryAddressSession | null {
  if (!addressFac) return null;

  const payload: FactoryAddressSession = {
    province_id: addressFac.province_id ?? null,
    province_name: addressFac.province_name ?? null,
    district_id: addressFac.district_id ?? null,
    district_name: addressFac.district_name ?? null,
    sub_district_id: addressFac.sub_district_id ?? null,
    sub_district_name: addressFac.sub_district_name ?? null,
    zip_code: addressFac.zip_code ?? null,
  };

  try {
    const raw = JSON.stringify(payload);
    // ✅ เก็บทั้ง sessionStorage (ตาม session ของ tab) และ localStorage (เผื่อเปิด tab ใหม่)
    sessionStorage.setItem(STORAGE_KEY, raw);
    localStorage.setItem(STORAGE_KEY, raw);
  } catch {
    // ignore storage errors (private mode / blocked)
  }

  return payload;
}

export function getFactoryAddressSession(): FactoryAddressSession | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY) ?? localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as FactoryAddressSession;
  } catch {
    return null;
  }
}

export function clearFactoryAddressSession() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}


